import { PUBLIC_NAME } from '../lib/config.js';

/** The logo files, made by scripts/brand-assets.mjs. Sizes are the files' own proportions. */
const FULL = { width: 162, height: 40 };
const MARK = { width: 42, height: 40 };

/**
 * The neuu logo. The full logo has a light and a dark file (the wordmark turns white), and the one
 * that matches the theme shows; the mark alone has one file. The name is the alt text, never typed.
 */
export function BrandLogo({ variant = 'full' }: { variant?: 'full' | 'mark' }) {
  if (variant === 'mark') {
    return <img className="brand-logo" src="/brand/mark.png" alt="" {...MARK} />;
  }
  return (
    <span className="brand-logo">
      <img className="brand-logo__light" src="/brand/logo.png" alt={PUBLIC_NAME} {...FULL} />
      <img className="brand-logo__dark" src="/brand/logo-dark.png" alt={PUBLIC_NAME} {...FULL} />
    </span>
  );
}
